import { useLoaderData } from "react-router-dom";
import {
  Wrapper,
  MainSection,
  PartnersSection,
  PilotssSection,
  Column,
  Title,
  Line,
} from "./style";

import { Header } from "../../components/Header/Header";
import { useEffect } from "react";
import { EventsNewsSection } from "../../components/EventsNewsSection/EventsNewsSection";
import { SM_MEDIA_QUERY_THRESHOLD } from "../../config";
import { getLatestEvent } from "../../utils/getLatestEvent";
import { replicatorz, sisters } from "../PastEvents/mocks";
import { DateTime } from "luxon";


export const AboutPage = () => {
  const { page, postList: postListRaw = [] } = useLoaderData();
  const isMobile = window.innerWidth <= SM_MEDIA_QUERY_THRESHOLD;
  const {
    main_title,
    header_bg_image,
    header_logo,
    pilots,
    pilots_sm,
    first_section_content,
    "partners _first_column": partners_first_column,
    "partners _second_column": partners_second_column,
    partners_title = "Partners",
    pilots_title = "Pilots",
  } = page[0].acf;

  useEffect(() => {
    if (window.location.search) {
      const id = window.location.search.match(/\w+$/gm)[0];
      const target = document.getElementById(id);
      target.scrollIntoView();
      // target.scrollIntoView({ behavior: "smooth" });
    }
  }, [window.location.search]);

  const postList = postListRaw.map(({ acf, id, }) => ({
    // const postList = postListRaw.map(({ acf, id, date_gmt: date }) => ({
    ...acf,
    id,
    // date,
  }));
  const event = getLatestEvent(postList);
  const news = postList
    .filter(({ type }) => type === "news")
    .sort(({ event_date: A }, { event_date: B }) =>
      DateTime.fromFormat(A, "dd/MM/yyyy h:mm a") > DateTime.fromFormat(B, "dd/MM/yyyy h:mm a") ? -1 : 1
    )
    // .sort(({ date: A, date: B }) =>
    //   new Date(A).getTime() > new Date(B).getTime() ? 1 : -1
    // )
    .filter((_, i) => i <= 1);
  const currentPilot = isMobile ? pilots_sm : pilots;
  const section1Full = first_section_content.length > 15;
  const partnersFUll =
    partners_first_column.length > 15 && partners_second_column.length > 15;
  const pilotsFull = currentPilot.length > 15;
  return (
    <>
      <Header
        title={main_title}
        subTile="About"
        content=""
        // imageBottomLeft={header_image_bottom_left?.url}
        // imageTopRight={header_image_top_right?.url}
        background={header_bg_image?.url}
        logo={header_logo.url}
        clearBg={true}
        smallHeader={isMobile}
      />
      <Wrapper>
        {section1Full && (
          <MainSection
            // dangerouslySetInnerHTML={{ __html: replicatorz }}
            dangerouslySetInnerHTML={{ __html: first_section_content }}
          />
        )}
        {partnersFUll ? (
          <>
            <Title
              id="partners"
              style={isMobile ? { marginBottom: "0px" } : {}}
            >
              {partners_title}
            </Title>

            <PartnersSection>
              {partners_first_column && (
                <Column
                  dangerouslySetInnerHTML={{ __html: partners_first_column }}
                />
              )}
              {partners_second_column && (
                <Column
                  style={isMobile ? { marginTop: "-90px" } : {}}
                  dangerouslySetInnerHTML={{ __html: partners_second_column }}
                />
              )}
            </PartnersSection>
          </>
        ) : (
          ""
        )}
        <Line />
        {pilotsFull && (
          <>
            <Title id="partners">{pilots_title}</Title>
            <PilotssSection
              dangerouslySetInnerHTML={{
                __html: currentPilot,
              }}
            />
          </>
        )}
      </Wrapper>
      <EventsNewsSection {...{ event, news }} />
    </>
  );
};
